import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ComponentWithForm } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services/auth.service';
import { ModalService } from '@services/modal.service';

@Injectable()
export class UnsavedFormGuard implements CanDeactivate<ComponentWithForm> {
    constructor(
        private _modalService: ModalService,
        private _translateService: TranslateService,
        private _authService: AuthService,
    ) { }

    canDeactivate(component: ComponentWithForm) {
        if (
            !component.hasUnsavedChanges ||
            this._authService.pendingLogout$.value
        ) {
            return true;
        }

        return this._modalService.onConfirm(null,
            () => { },
            () => { },
            this._translateService.instant('dirty_form_confirmation'),
        );
    }
}
